import { AssetfiAssetType } from '@/types/asset-type';

export default function SymbolSvg ({ width, height }: AssetfiAssetType) {
  // const width = '630';
  // const height = '630';
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#D9D9D9" />
    </svg>
  );
};
